module.exports = __webpack_public_path__ + "static/imoen-mystic-trickster-mtg_cls-fc568ceb9bcef48bbc48f655ec6b68b6.jpg";